import { render, staticRenderFns } from "./CreateTagModal.vue?vue&type=template&id=0388744b&scoped=true&"
import script from "./CreateTagModal.vue?vue&type=script&lang=js&"
export * from "./CreateTagModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTagModal.vue?vue&type=style&index=0&id=0388744b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388744b",
  null
  
)

export default component.exports